import { useEffect, useState } from "react";
import type { z } from "zod/v4";
import { ButtonPrimitive } from "@/components/ButtonPrimitive";
import { Section } from "@/components/Section";
import { Text } from "@/components/Text";
import type { ThankYouRedirectPropsSchema } from "@/schemas/sections";
import type { SectionWrapperProps } from "@/types/section-wrapper";

export type ThankYouRedirectSectionProps = z.input<typeof ThankYouRedirectPropsSchema> &
  SectionWrapperProps;

export function ThankYouRedirect({
  title,
  subtitle,
  redirectUrl = "/",
  delaySeconds = 3,
  buttonText = "Вернуться на главную",
  redirectingLabel = "Перенаправляем на главную через",
  id,
  background,
  padding,
  className,
}: ThankYouRedirectSectionProps) {
  const [seconds, setSeconds] = useState(delaySeconds);

  useEffect(() => {
    if (seconds <= 0) {
      window.location.href = redirectUrl;
      return;
    }
    const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
    return () => clearTimeout(timer);
  }, [seconds, redirectUrl]);

  return (
    <Section id={id} background={background} padding={padding} className={className}>
      <div data-component="ThankYouRedirect" className="text-center">
        <Text variant="title" className="mb-4">
          {title}
        </Text>
        <Text variant="body-lg" className="text-muted mb-6">
          {subtitle}
        </Text>
        <ButtonPrimitive as="a" href={redirectUrl} variant="ghost" size="md" className="mb-4">
          {buttonText}
        </ButtonPrimitive>
        <Text variant="body-sm" className="text-muted">
          {redirectingLabel} {seconds} сек...
        </Text>
      </div>
    </Section>
  );
}

ThankYouRedirect.displayName = "ThankYouRedirect";
